import React from 'react';
import AKSearchIcon from '@atlaskit/icon/glyph/search';
import type { Size } from '@atlaskit/icon/types';
import { token } from '@atlaskit/tokens';
import { N800 } from '@atlaskit/theme/colors';

import type { SearchCSS } from '../theme';

interface Props {
	isExpanded: boolean;
	theme: SearchCSS;
	/**
	 * @default 'small'
	 */
	size?: Size;
	primaryColor?: string;
	label?: string;
}

export const SearchIcon = ({
	isExpanded,
	theme,
	size = 'small',
	primaryColor = token('color.text', N800),
	label = '',
}: Props) => (
	<AKSearchIcon
		label={label}
		primaryColor={isExpanded ? primaryColor : theme.default.color}
		size={size}
	/>
);
